import {
    Chip, Icon
} from '@mui/material'

import {forwardRef} from 'react'

import Styles from './style'

export const Tag = forwardRef((props, ref) => {
    const color = props.color || 'blue'
    const variant = props.variant ||  'main'

    const loadedColor = {
        borderColor: Styles.colors[color.toLowerCase()][variant.toLowerCase()].border,
        background: Styles.colors[color.toLowerCase()][variant.toLowerCase()].background,
        color: Styles.colors[color.toLowerCase()][variant.toLowerCase()].color
    }

    const closeIconSx = {
        color: `${Styles.colors[color.toLowerCase()][variant.toLowerCase()].color} !important`,
        fontSize: '16px !important',
        fontWeight: '400 !important',
        ['&:hover']: {
            color: `${Styles.colors[color.toLowerCase()][variant.toLowerCase()].color} !important`
        }
    }

    const cmp = (
        <Chip
            style={loadedColor}
            sx={props.sx || {}}
            deleteIcon={<Icon sx={closeIconSx}>{props.deleteIcon || 'close'}</Icon>}
            label={props.label || ''}
            {...props.chip}
            ref={ref}
        />
    )

    return (cmp)
})

Tag.displayName = 'Tag'

export default Tag